"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var swr_hooks_1 = require("@l2p/swr-hooks");
var swr_hooks_2 = require("@l2p/swr-hooks");
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var react_1 = __importStar(require("react"));
var react_final_form_1 = require("react-final-form");
var styles_module_scss_1 = __importDefault(require("../styles.module.scss"));
var Country = function (_a) {
    var withLabels = _a.withLabels, authInputMode = _a.authInputMode, _b = _a.withRequiredLabel, withRequiredLabel = _b === void 0 ? false : _b;
    var t = (0, next_intl_1.useTranslations)('translation');
    var form = (0, react_final_form_1.useForm)();
    var countries = (0, swr_hooks_1.useCountriesOptions)({ applyGeoRestrictions: true });
    var currencies = (0, swr_hooks_2.useGenerateCurrencies)();
    var countriesData = (0, swr_hooks_2.useCountries)().data;
    var changeCountryHandler = (0, react_1.useCallback)(function (event) {
        var countryCurrency = countriesData === null || countriesData === void 0 ? void 0 : countriesData.find(function (country) { return country.code === event.value; });
        var currencyToSelect = currencies.find(function (currency) { return currency.value === (countryCurrency === null || countryCurrency === void 0 ? void 0 : countryCurrency.currencyCode); });
        if (currencyToSelect)
            form.change('currency', currencyToSelect);
    }, [currencies, countriesData, form]);
    return (react_1.default.createElement(react_final_form_1.Field, { name: "country", render: function (_a) {
            var _b;
            var input = _a.input, meta = _a.meta;
            return (react_1.default.createElement("div", { className: styles_module_scss_1.default.fieldWrapper },
                react_1.default.createElement(ui_components_1.InputSelect, __assign({}, input, { withRequiredLabel: withRequiredLabel, mode: authInputMode, options: countries, labelText: withLabels ? t('country') : undefined, placeholder: t('selectCountry'), hasError: meta.error && meta.touched, onChange: function (event) {
                        input.onChange(event);
                        changeCountryHandler(event);
                    } })),
                meta.error && meta.touched && (react_1.default.createElement(ui_components_1.ErrorText, null, (_b = meta.error) === null || _b === void 0 ? void 0 : _b.value))));
        } }));
};
exports.default = Country;
